export default {
    test: 'hello world',
    loading: 'Loading...',
    // Shown under a message the form moves past on its own (phone verified, too many attempts, Flinks retries).
    continuing: 'Continuing…',
    from_prepop_get_loan: 'Continue with your application to get your loan',
    you_were_referred_by: 'You were referred by',
    prepop_welcome_kicker: 'Pre-Qualified',
    prepop_welcome_title: "You're almost there!",
    prepop_welcome_body: 'Finish your application in under <strong>2 minutes</strong> and unlock your exclusive loan rate.',
    prepop_welcome_trust: 'No commitment · 100% secure',
    components: {
        form: {},
        field: {},
        flinks: {
            max_retry_reached: 'Maximum retries reached, skipping to next step.',
        },
        smsverification: {
            edit_phone: 'Edit phone',
            verify_code: 'Verify',
            verified_success: 'Your phone number has been successfully verified!',
            max_attempts_reached: 'You have reached the maximum number of attempts.',
            verification_code_sent: 'You will receive a verification code by SMS, standard messaging or data rates may apply.',
            new_accounts_must_verify: 'For security reasons new accounts must verify their phone numbers.',
            last_attempt: 'You have 1 attempt left.',
            sent_sms_to: 'Sent SMS code to:',
            resend_code: 'Request another code',
            resend_code_in: 'You can request another code in',
            seconds: 'seconds',
            skip_verification_car_loan: `<small><b class="text-primary">Important:</b> You can skip this step but your options may be limited.</small>`,
            skip_verification_member_enrollment: `<small><b class="text-primary">Important:</b> You can skip this step by pressing the button below, but you won’t be able to create an account.</small>`,
            enter_valid_code: 'Please enter a valid verification code.',
            enter_valid_phone: 'Please enter a valid phone number.',
            enter_valid_phone_ca: 'Please enter a valid canadian phone number.',
            enter_valid_phone_us: 'Please enter a valid U.S. phone number.',
            sms_code_could_not_send: "We couldn't send an SMS code to the provided number. Please ensure it's correct and try again.",
            sms_code_is_incorrect: "The code you provided is incorrect. Please try again.",
            enter_phone: 'Enter your phone number',
            enter_code: 'Enter the verification code',
        }
    },
    validations: {
        invalid_data: 'Please check this entry.',
        postal_code_format: 'Enter a postal code like H2X 1Y4.',
        zip_code_format: 'Enter a 5-digit ZIP code, like 10001.',
        required_choice: 'Please choose an option.',
        required_field: 'Please fill in this field.',
        max_length: 'This entry is too long. Please shorten it.',
        email_undeliverable: "We couldn't verify this email address. Please check it for typos.",
        email_required: "Enter a valid email address, like name{'@'}example.com.",
        phone_format: 'Enter a 10-digit phone number.',
        phone_canadian: 'Enter a 10-digit Canadian phone number.',
        phone_us: 'Enter a 10-digit US phone number.',
        password: 'Password must be at least 8 characters, contain one uppercase letter, one lowercase letter and one number.',
        password_confirmation: 'Passwords do not match.',
        email_confirmation: 'Emails do not match.',
        name: 'Use letters, spaces, hyphens and apostrophes only.',
        dob: 'Choose your date of birth. You must be 18 or older.',
        date: 'Choose a date from the calendar.',
        month_year: 'Please select a month and year',
        in_choices: 'Please select one of the options',
        paydate: 'Choose a pay date between tomorrow and 3 months from today.',
        sin: 'Enter your 9-digit SIN.',
        invalid_character: 'Please remove special characters.',
        numeric: 'Enter numbers only.',
        car_year: "Enter the car's year, like 2018.",
        rate: 'Enter your rate as a number, like 7 or 6.99.',
        drivers_license: 'You must be 18+ and hold a driver\'s license in order to qualify for a car loan',
        address_required: 'Enter your address.',
        property_mortgage: 'Mortgage must be less than the property value'
    },
    steps: {
        titles: {
            requested_amount_business: 'Funding amount desired',
            requested_amount: 'How much would you like to borrow?',
            requested_amount_debt: 'How much do you need to consolidate your debt?',
            product_purpose: 'What is the purpose of the loan?',
            cc_debt_amount: 'Credit Card Debt Amount',
            unsecured_debt_amount: 'Total Other Unsecured Debt',
            in_credit_situation: 'What is your estimated credit score?',
            income_type: 'Select your main income source',
            current_income_source: 'What is your current income source?',
            income_type_other: 'Do you have any other sources of income? <br><small>Select all that apply</small>',
            direct_deposit: 'Do you receive your income by direct deposit?',
            monthly_income: 'Select your monthly income',
            gross_monthly_income: 'What is your gross monthly income?',
            monthly_income_input: 'Enter your monthly income',
            monthly_other_income_input: 'Enter your monthly income',
            address: 'What is your address?',
            address_length_months: 'How long have you been at this address?',
            address_length_months_current: 'How long have you been at your current address?',
            own_home: 'Are you a homeowner?',
            living_situation: 'Tell us about your living situation',
            dob: 'What is your date of birth?',
            employer_information: 'Please enter your employment information',
            employed_months: 'How long have you been at this job?',
            employed_months_how_long: 'How long have you been employed?',
            pay_frequency: 'How often do you get paid?',
            pay_date1: 'What is your next pay date?',
            flinks_personal_loan: 'Select the bank account you want your money deposited to',
            flinks_car_loan: 'Confirm the account you wish to make your auto payments with',
            flinks_powersports: 'Confirm the account you wish to make your payments with',
            how_to_contact: 'How can we reach you?',
            phone_verification: 'Phone Verification',
            lets_create_your_account: "Let's create your account!",
            create_comparehub_account: "Do you want to create an account with us?",
            citizen_status: "Select your citizenship status",
            credit_card_debt_amount: "Credit Card Debt Amount",
            is_last_step: "This is the last step!",
            wants_equifax_verification: "Do you want to get verified with Equifax to obtain your FREE credit score and report?",
            confirm_information: "Please confirm your information below before continuing",
            sms_verification: 'Please confirm your phone number with the verification code that will be sent to your phone',
            lets_get_you_approved: "Let's get you approved!",
            postal_code: 'Enter your postal code',
            zip: 'Enter your ZIP',
            phone_number_work: 'Work Phone',
            ssn: 'Social Security Number',
            in_military: 'Are you military or military connected?',
            bank_account_type: 'Where would you like to receive your funds?',
            bank_account_details: 'Where would you like to receive your funds?',
            drivers_license: "Driver's License",

            // car loan application
            car_request_type: 'Select the type of car you want to buy',
            car_request_monthly_budget: "What's your monthly budget?",
            car_in_credit_situation: "What is your estimated credit score?",
            car_request_sms_verification_code: "Please verify your vehicle preference by requesting a phone verification code",

            // life insurance
            requested_amount_life_insurance: 'How much coverage would you like?',
            what_province: 'What province do you live in?',
            select_gender: 'Select your gender',
            were_you_born_male_or_female: 'Were you born male or female?',
            title_salutation: 'Salutation',
            what_is_your_name: 'What is your name?',
            do_you_smoke_or_vape: 'Do you smoke or vape?',

            // powersports
            what_are_you_looking_for: 'What are you looking to buy?',
            requested_amount_powersports: 'What is the value of the item you want to finance?',

            // business loan
            business_start_date: 'Business start date (estimated)',
            equity: 'Equity',
            business_assets: 'Business Assets',
            company_information: 'Company Information',
            average_monthly_revenue: 'Average monthly revenue',
            notice_of_assessment: 'Notice of Assessment (NOA)',
            purpose_of_funds: 'What will you use the funds for?',
            has_business_bank_account: 'Does the business have its own bank account?',
            ownership_percentage: 'What share of the business do you own?',
            insolvency_consultation: 'Have you ever consulted a Licensed Insolvency Trustee or a credit counsellor?',
            monthly_mortgage_payment: 'What is your monthly mortgage payment?',
            monthly_rent: 'What is your monthly rent?',
            // car refinancing
            lower_car_loan_payments: `<h3 class="my-3 text-center h2">Lower Your Car Loan Payments</h3>`,
            tell_us_about_current_vehicle: 'Tell us about your current vehicle',
            tell_us_about_current_financing: 'Tell us about your current car financing',
            do_you_have_proof_of_income: 'Do you have proof of income?',
            // debt settlement / credit repair
            financial_profile: 'Let\'s go over your financial profile',
            in_bankruptcy: 'Are you currently in bankruptcy?',
            in_dmp: 'Are you currently in a debt management program?',
            in_consumer_proposal: 'Are you currently in a consumer proposal?',
            // asset based
            asset_information: 'Tell us about the asset',
            //heloc
            more_information_needed: '<h4 class="text-center col-md-10 mx-auto">We just need a little more information to continue...</h4>'
        },
        textTop: {
            hard_credit_check: `<div class="col-md-12 py-2" style="margin-top:30px;">To maximize your chance of finding a service provider, we recommend you authorize our provider network with permission to obtain credit reports from credit reporting agencies to assess your credit history and make approval decisions. By selecting "<b class="text-secondary">Maximize my approval chances</b>" matched provider(s) can check your credit report to make complete approval decisions based on your request and you can be funded faster. Otherwise, you agree that your consent is limited only to a soft credit check and you are limiting your approval opportunities. Your consent is valid until you notify the matched provider of your consent withdrawal.</div>`,
            create_comparehub_account_benefits: `
                <p>By creating an account you can:
                    <ul>
                        <li>Increase your qualification chances</li>
                        <li>Track your application history</li>
                        <li>Speed up future applications</li>
                        <li><b>Get your free Equifax credit score!</b></li>
                    </ul>
                </p>
                <h6 class="text-center text-dark mt-3">Creating Your Free Credit Score Account Won't Impact Your Credit</h6>
            `,
            get_options_with_consent: `<p class="text-muted h5 my-3 text-center">Are you ready to receive your recommendations by electronic messages and see your loan options?</p>`,
            prequalify_best_providers: `<h6 class="text-center text-dark mt-3">Continuing will help us pre-qualify you with the best providers</h6>`,
            unsecured_debt_amount_definition: `<p class="text-muted my-3 text-center">Unsecured debt refers to payday or personal loans and telecom bills, but excludes credit card balances, car loans and mortgages.</p>`,
        },
        hint: {
            business_start_date_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Most lenders require the business to have been operating and earning revenue for at least 6 months.</p>`,
            average_monthly_revenue_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Everything your business brings in each month, before expenses.<span class="d-block mt-1">Most lenders require at least <b>$10,000</b> in verifiable total sales per month.</span></p>`,
            business_structure_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;"><b>Corporation:</b> the name ends in Inc., Ltd. or Corp.<br><b>Sole proprietorship:</b> you never incorporated (self-employed or a registered business name).<br><b>Partnership:</b> two or more owners, not incorporated.<span class="d-block mt-1"><em>Not sure? Pick "Other / not sure", it won't stop your application.</em></span></p>`,
            hard_credit_check_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">To maximize your chance of finding a service provider, we recommend you authorize our provider network with permission to obtain credit reports from credit reporting agencies to assess your credit history and make approval decisions. By selecting "<b class="text-secondary">Maximize my approval chances</b>" matched provider(s) can check your credit report to make complete approval decisions based on your request and you can be funded faster. Otherwise, you agree that your consent is limited only to a soft credit check and you are limiting your approval opportunities. Your consent is valid until you notify the matched provider of your consent withdrawal.</p>`,
            unsecured_debt_amount_definition_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Unsecured debt refers to payday or personal loans and telecom bills, but excludes credit card balances, car loans and mortgages.</p>`,
            bank_account_type_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Lenders are more likely to approve applicants with a checking account.</p>`,
            driver_license_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Your state-issued ID or driver's license number is used to verify your identity and protect you from fraud.</p>`,
            work_phone_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Required by most lenders. Your employer will never be contacted about your loan request. If you are not currently employed, please provide the phone number of the organization or agency where you are receiving benefits.</p>`,
            ssn_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Your SSN is used to verify your identity. All information is encrypted and automatically deleted within 7 days of submission.</p>`,
            employer_information_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">We collect employment details to verify income and speed up your loan approval. If you receive benefits, please enter the name of the agency or organization.</p>`,
            employed_months_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">This helps us understand your financial situation and offer options that fit your needs. If you're not currently employed, tell us how long you worked at your previous job.</p>`,
            pay_frequency_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">If you are not currently employed, please let us know how often you receive any benefits or income.</p>`,
            gross_monthly_income_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Include your total available income from all sources. This may include employment, benefits, pensions, investments, rental income, and self-employment income.</p>`,
            void_check: `<div style="max-width: 75%; margin: 0 auto;"><img src="/assets/images/hints/void-check.png" class="img-fluid mb-2" alt="Void check example" /></div>`,
        },
        notice: {
            prepop_contact_greeting: 'You\'re one step closer to approval!<br><small>Confirm your info below to continue.</small>',
            prepop_confirm_address: 'Make sure your address is right so we can find you the best offers',
            prepop_verify_phone: 'You\'re almost there! Verify your phone to unlock your personalized loan offers',
        },
        textBottom: {
            footer_credit_disclaimer: '<p class="text-muted text-center my-3"><small>By completing this form I authorize the trusted financial services provider I\'ve been matched with to obtain credit reports from credit reporting agencies to assess my credit history. My consent is valid until I notify the matched provider of its withdrawal.</small></p>',
            flinks_skip: '<div class="text-center col-md-12 py-2" style="margin-top:30px;"><b class="text-primary">Important:</b> You can skip this step by pressing the button below, however your approval chances may be impacted.<br><br><small>By providing your bank login details, you confirm you are aware of any contractual obligations with your financial institution.</small></div>',
            comparehub_member_pp_tc: `By creating an account you will become a CompareHub member and will receive access to learning resources, personalized recommendations and the option to obtain your free Equifax credit score. For more information please review our <a href="https://loanscanada.ca/privacy-policy/" target="_blank">Privacy Policy</a> and <a href="https://loanscanada.ca/terms/" target="_blank">Terms of Use</a>. This does not affect your credit score.`,
            create_comparehub_account_opt_in: `<p class="text-muted small">By creating an account you will become a CompareHub member and will receive access to learning resources, personalized recommendations and the option to obtain your free Equifax credit score. For more information please review our <a href="https://loanscanada.ca/privacy-policy/" target="_blank">Privacy Policy</a> and <a href="https://loanscanada.ca/terms/" target="_blank">Terms of Use</a>. <b>This does not affect your credit score.</b></p>`,
            consent_text: `<p class="text-muted text-center my-3"><small>By completing this form I authorize the trusted financial services provider I've been matched with to obtain credit reports from credit reporting agencies to assess my credit history (this will not affect your credit score). My consent is valid until I notify the matched provider of its withdrawal.</small></p>`,
            opt_in_text: `<p class="text-muted text-center my-3"><small>By selecting 'Yes' you agree to receive promotions and updates from {brand} & CompareHub.</small></p>`,
            us_consent: `<p class="text-center" style="font-size:13px; color:#6b7280;">By clicking "Next", I agree to the  <a href="https://app.reboundfinance.com/terms/" target="_blank">Terms of Use</a> and <a href="https://app.reboundfinance.com/privacy-policy/" target="_blank">Privacy Policy</a> and authorize Rebound Finance and its marketing partners, including the lenders and service providers listed <a href="#" class="partners-disclosure-btn" onclick="window.showPartnersList()">here</a>, to contact me at the number and email address I provided, including via: autodialed calls, artificial or prerecorded voices, text messages (SMS/MMS) and email. Message and data rates may apply (you can reply "STOP" to opt out). I am not required to obtain goods or services or to be connected with any of the service providers that can fit my needs. Further, by providing my e-mail, I authorize and give Rebound Finance my express written consent, to receive electronic communications, including periodic emails with important news, financial tips, tools, promotions (including third party offers) and more from Rebound Finance. I understand that I can always withdraw my consent or unsubscribe at any time.</p>`,
        },
        textBottomBelowActionButtons: {
            terms_privacy_consent: `
                <p style="font-size:13px; color:#6b7280;">{terms_privacy_consent}</p>
            `,
            credit_history_authorization_1: `
                <p style="font-size:13px; color:#6b7280;">{credit_history_authorization_1}</p>
            `,
            credit_history_authorization_1_car_loan: `
                <p style="font-size:13px; color:#6b7280;">{credit_history_authorization_1_car_loan}</p>
            `,
            credit_history_authorization_1_car_refinancing: `
                <p style="font-size:13px; color:#6b7280;">{credit_history_authorization_1_car_refinancing}</p>
            `,
            credit_history_authorization_1_insurance: `
                <p style="font-size:13px; color:#6b7280;">{credit_history_authorization_1_insurance}</p>
            `,
            rebound_consent_heloc: `<p class="text-center" style="font-size:13px; color:#6b7280;">By clicking "Next", I agree to the  <a href="https://app.reboundfinance.com/terms/" target="_blank">Terms of Use</a> and <a href="https://app.reboundfinance.com/privacy-policy/" target="_blank">Privacy Policy</a> and authorize Rebound Finance and its marketing partners, including the lenders and service providers listed <a href="#" class="partners-disclosure-btn" onclick="window.showPartnersList()">here</a>, to contact me at the number and email address I provided, including via: autodialed calls, artificial or prerecorded voices, text messages (SMS/MMS) and email. Message and data rates may apply (you can reply "STOP" to opt out). I am not required to obtain goods or services or to be connected with any of the service providers that can fit my needs. Further, by providing my e-mail, I authorize and give Rebound Finance my express written consent, to receive electronic communications, including periodic emails with important news, financial tips, tools, promotions (including third party offers) and more from Rebound Finance. I understand that I can always withdraw my consent or unsubscribe at any time.</p>`
        },
    },
    fields: {
        help: {
            round_rate: 'Round it to a whole number (6.99% → 7).',
        },
        labels: {
            requested_amount: 'How much would you like to borrow?',
            rent_mortgage_payment: 'Rent/Mortgage Payment',
            monthly_rent_or_mortgage_payment: 'Monthly rent or mortgage payment (enter 0 if none)',
            property_value: 'Property Value',
            property_mortgage: 'Property Mortgage',
            first_name: 'First Name',
            last_name: 'Last Name',
            email_address: 'Email Address',
            confirm_email: 'Confirm your email address',
            phone: 'Phone',
            phone_number: 'Phone Number',
            employer_name: 'Employer Name',
            job_title: 'Occupation',
            phone_number_work: 'Work Phone',
            address_civic_number: 'Civic Number',
            address_street: 'Street',
            address_unit_number: 'Unit Number',
            address_postal_code: 'Postal Code',
            address_zip: 'ZIP',
            address_city: 'City',
            address_province: 'Province',
            address_state: 'State',
            password: 'Password',
            confirm_password: 'Confirm your password',
            dob: 'What is your date of birth?',
            sin_optional: 'SIN (Optional)',
            your_address: 'Your Address',
            answer_not_provided: 'The answer was not provided.',
            monthly_income: 'Monthly Income',
            monthly_income_employment: 'Monthly Employment Income',
            monthly_income_pension: 'Monthly Retirement Income',
            monthly_other_income: 'Other Monthly Income',
            postal_code: 'Postal Code',
            zip: 'ZIP',
            province: 'Province',
            state: 'State',
            last_years_income: 'Last Year\'s Income',
            year_before_last_income: 'Year before last\'s income',
            liquid_equity: `Liquid equity <br>(cash, stocks, bonds, ETFs)`,
            non_liquid_equity: `Non-liquid equity <br>(equipment, real estate, vehicles)`,
            company_name: 'Company Name',
            gross_sales_monthly: 'Gross sales (monthly)',
            gross_sales_cards: 'Gross sales (cards only)',
            average_monthly_sales: 'Average monthly sales',
            average_monthly_sales_cards: 'Average monthly Credit/Debit sales',
            industry: 'Industry',
            payment_processor: 'Who is your payment processor?',
            // The icon matches the step hint above the field, telling the user that note is about this question.
            business_structure: `Business structure <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" class="text-secondary ms-1 align-text-bottom" style="width: 0.9rem; height: 0.9rem;" role="img" aria-label="See the note above"><title>See the note above</title><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>`,
            number_of_employees: 'Number of employees, including you',
            // car refinancing
            car_ownership_status: 'Car Ownership Status',
            car_value: 'Car Value',
            car_refinancing_balance: 'Car Financing Balance',
            car_year: 'Car Year',
            car_mileage: 'Car Mileage (KMs)',
            car_make: 'Car Make',
            car_model: 'Car Model',
            car_current_lender: 'Current Lender',
            car_current_loan_rate: 'Current Loan Rate',
            car_current_loan_monthly_payment: 'Monthly Payment',
            car_loan_remaining_months: 'Remaining Months',
            title_salutation: "Salutation",
            routing_number: 'Routing Number',
            account_number: 'Account Number',
            bank_name: 'Bank Name',
            bank_account_length_months: 'How long have you had this account?',
            employed_months: 'How long have you been at this job?',
            license_id: 'License ID or number',
            license_state: 'License State',
            // debt / financial profile
            in_bankruptcy: 'Are you currently in bankruptcy?',
            in_dmp: 'Are you currently in a debt management program?',
            in_consumer_proposal: 'Are you currently in a consumer proposal?',
            business_start_date: 'Business Start Date',
            // asset based
            asset_type: 'Asset Type',
            asset_type_custom: 'Describe Your Asset',
            asset_value: 'Asset Value',
            asset_financed: 'Is the asset financed?',
            asset_financing_amount: 'Asset Financing Amount',
            new_asset_name: 'Describe The Asset',
            new_asset_value: 'Asset Purchase Price',
        },
        options: {
            opt_yes: "Yes",
            opt_no: "No",
            opt_not_right_now: "Not right now",
            //requested_amount
            opt_1000_less: "$1,000 or less",
            opt_1001_5000: "$1,001 to $5,000",
            opt_5001_10000: "$5,001 to $10,000",
            opt_10001_15000: "$10,001 to $15,000",
            opt_15001_20000: "$15,001 to $20,000",
            opt_20000_more: "More than $20,000",
            opt_20001_50000: "$20,001 to $50,000",
            opt_50000_more: "More than $50,000",
            opt_amount_1001_2000: "$1,001 to $2,000",
            opt_amount_2001_3000: "$2,001 to $3,000",
            opt_amount_3001_4000: "$3,001 to $4,000",
            opt_amount_4001_5000: "$4,001 to $5,000",
            opt_amount_2001_5000: "$2,001 to $5,000",
            // product_purpose
            opt_debt_consolidation: "Debt Consolidation",
            opt_cc_consolidation: "Credit Card Consolidation",
            opt_emergency_expense: "Emergency Expense",
            opt_car_repair: "Car Repair",
            opt_other: "Other",
            // cc_debt_amount
            // unsecured_debt_amount
            opt_debt_no_cc_debt: "No Credit Card Debt",
            opt_debt_no_unsecured_debt: "No Other Unsecured Debt",
            opt_debt_amounts_2500_less: "Less than $2,500",
            opt_debt_amounts_2501_5000: "$2,501 to $5,000",
            opt_debt_amounts_5001_10000: "$5,001 to $10,000",
            opt_debt_amounts_10001_15000: "$10,001 to $15,000",
            opt_debt_amounts_15001_20000: "$15,001 to $20,000",
            opt_debt_amounts_20001_25000: "$20,001 to $25,000",
            opt_debt_amounts_25000_more: "More than $25,000",
            // in_credit_situation
            opt_in_credit_situation_good: "Good (Over 700)",
            opt_in_credit_situation_fair: "Fair (550 - 700)",
            opt_in_credit_situation_low: "Low (Under 550)",
            opt_in_credit_situation_cp: "Current Consumer Proposal",
            opt_in_credit_situation_bk: "Current Bankruptcy",
            opt_in_credit_situation_unknown: "Not Sure",
            // income_type
            opt_income_type_full: "Full-Time Employed",
            opt_income_type_part: "Part-Time Employed",
            opt_income_type_self: "Self-Employed",
            opt_income_type_benefits: "Child Tax Benefits / EI",
            opt_income_type_disability: "Disability",
            opt_income_type_pension: "Pension / CPP / OAS",
            opt_income_type_unemployed: "Not Working",
            opt_income_type_other: "Other",
            //other income types
            opt_income_type_other_wsib: "WSIB",
            opt_income_type_other_short_term_disability: "Short Term Disability",
            opt_income_type_other_long_term_disability: "Long Term Disability",
            opt_income_type_other_social_security: "Employment insurance",
            opt_income_type_other_child_tax_benefit: "Child Tax Benefit",
            opt_income_type_other_rental_income: "Rental Income",
            opt_income_type_other_other: "Other",
            opt_income_type_other_none: "None",
            // monthly_income
            opt_1500_less: "$1500 or less",
            opt_1501_2000: "$1501 to $2000",
            opt_2001_3000: "$2001 to $3000",
            opt_3001_4000: "$3001 to $4000",
            opt_4001_5000: "$4001 to $5000",
            opt_5000_more: "More than $5000",
            // employed_months
            opt_employed_months_3_less: "Under 3 months",
            opt_employed_months_3_6: "3 to 6 months",
            opt_employed_months_6_12: "6 to 12 months",
            opt_employed_months_12_more: "1 year or more",
            // pay_frequency
            opt_weekly: "Weekly",
            opt_bi_weekly: "Bi-Weekly",
            opt_semi_monthly: "Semi-Monthly",
            opt_monthly: "Monthly",
            // address_length_months
            opt_address_length_months_3_less: "Under 3 months",
            opt_address_length_months_3_6: "3 to 6 months",
            opt_address_length_months_6_12: "6 to 12 months",
            opt_address_length_months_12_more: "1 year or more",
            // opt_in & credit consent
            opt_opt_in_consent: `Receive promotions and updates from {brand} by email. You can opt-out at any time. By clicking 'Next' you agree to the <a href="https://loanscanada.ca/terms/" target="_blank">terms of use</a> and <a href="https://loanscanada.ca/privacy-policy/" target="_blank">privacy policy</a>.`,
            opt_opt_in_consent_by_lc: `Receive promotions and updates from {brand} by Loans Canada by email. You can opt-out at any time. By clicking 'Next' you agree to the <a href="https://loanscanada.ca/terms/" target="_blank">terms of use</a> and <a href="https://loanscanada.ca/privacy-policy/" target="_blank">privacy policy</a>.`,
            opt_opt_in_consent_by_comparehub: `Receive promotions and updates from {brand} by CompareHub by email. You can opt-out at any time. By clicking 'Next' you agree to the <a href="https://loanscanada.ca/terms/" target="_blank">terms of use</a> and <a href="https://loanscanada.ca/privacy-policy/" target="_blank">privacy policy</a>.`,
            opt_credit_auth_1: 'Show me other options',
            opt_credit_auth_2: 'Maximize my approval chances',
            // canadian status
            opt_cs_citizen: "Citizen",
            opt_cs_permanent: "Permanent Resident",
            opt_cs_work: "Work Permit",
            opt_cs_student: "Student Visa",
            opt_cs_visitor: "Visitor",
            opt_cs_other: "Other",
            // options_opt_in
            opt_continue_with_consent_yes: "Yes, and show me my loan options!",
            opt_continue_with_consent_no: "Continue to my loan options only",
            // car_request_type
            opt_car_type_sedan: 'Car',
            opt_car_type_suv: 'SUV',
            opt_car_type_van: 'Van',
            opt_car_type_truck: 'Truck',
            // car_request_monthly_budget
            opt_car_budget_200_less: 'Up to $200',
            opt_car_budget_201_350: '$201 to $350',
            opt_car_budget_351_500: '$351 to $500',
            opt_car_budget_501_more: '$501 or more',
            // life insurance
            //requested_amount
            opt_100k_less: "$100,000 or less",
            opt_100k_250k: "$100,001 to $250,000",
            opt_250k_500k: "$250,001 to $500,000",
            opt_500k_1m: "$500,001 to $1,000,000",
            opt_1m_more: "More than $1,000,000",
            // title
            opt_title_male: "Male",
            opt_title_female: "Female",
            // powersports
            opt_powersports_rv: "RVs",
            opt_powersports_boat: "Boats",
            opt_powersports_tractor: "Garden Tractors",
            opt_powersports_atv: "All-Terrain Vehicles (ATVs)",
            opt_powersports_motorcycle: "Motorcycles",
            opt_powersports_snowmobile: "Snowmobiles",
            opt_powersports_ebike: "E-bikes",
            opt_powersports_personalwatercraft: 'Personal Watercraft <span style="font-size: 0.75rem; display:block;">(e.g., Jet Skis, Sea-Doos, Boats)</span>',
            opt_powersports_camper: "Campers",
            opt_powersports_heavyequipment: "Heavy Equipment",
            // business loan
            // - business_type "Other" on the POS financing form
            opt_business_type_other: "OTHER",
            // - business_type on the business and payment-processing forms (15 broad industries)
            opt_business_industry_automotive: "Auto-related (repair, dealership, car wash)",
            opt_business_industry_beauty: "Beauty salon, barber or spa",
            opt_business_industry_cannabis: "Cannabis, vape or smoke shop",
            opt_business_industry_construction: "Construction & trades",
            opt_business_industry_recreation: "Entertainment, fitness & recreation",
            opt_business_industry_health: "Health care & medical",
            opt_business_industry_manufacturing: "Manufacturing & wholesale",
            opt_business_industry_online_store: "Online store / e-commerce",
            opt_business_industry_professional_services: "Professional & business services (legal, accounting, finance, insurance, consulting, marketing)",
            opt_business_industry_real_estate: "Real estate",
            opt_business_industry_restaurant: "Restaurant, café or bar",
            opt_business_industry_retail: "Retail store",
            opt_business_industry_technology: "Technology & IT",
            opt_business_industry_transportation: "Trucking & transportation",
            opt_business_industry_other: "Other",
            // - business_structure (explanations live in steps.hint.business_structure_hint)
            opt_business_structure_corporation: "Corporation",
            opt_business_structure_sole_proprietorship: "Sole proprietorship",
            opt_business_structure_general_partnership: "Partnership",
            opt_business_structure_limited_partnership: "Limited partnership (LP)",
            opt_business_structure_non_profit: "Non-profit or charity",
            opt_business_structure_other: "Other / not sure",
            // - ownership_percentage (value = lower bound of the bucket)
            opt_ownership_percentage_100: "I'm the only owner",
            opt_ownership_percentage_51: "More than half",
            opt_ownership_percentage_50: "Exactly half",
            opt_ownership_percentage_1: "Less than half",
            // - rent_mortgage_payment (values are representative amounts; owners and renters see different bands)
            opt_rent_mortgage_payment_0_owner: "No mortgage, it's paid off",
            opt_rent_mortgage_payment_0_renter: "I don't pay rent",
            opt_rent_mortgage_payment_250: "Less than $500",
            opt_rent_mortgage_payment_625: "$500 to $749",
            opt_rent_mortgage_payment_750: "$500 to $999",
            opt_rent_mortgage_payment_875: "$750 to $999",
            opt_rent_mortgage_payment_1250: "$1,000 to $1,499",
            opt_rent_mortgage_payment_1800: "$1,500 or more",
            opt_rent_mortgage_payment_2000: "$1,500 to $2,499",
            opt_rent_mortgage_payment_3000: "$2,500 or more",
            // - insolvency_consultation
            opt_insolvency_consultation_none: "No, never",
            opt_insolvency_consultation_within_6_months: "Yes, in the last 6 months",
            opt_insolvency_consultation_over_6_months: "Yes, more than 6 months ago",
            // - product_purpose (business)
            opt_business_purpose_everyday_operations: "Everyday operations & cash flow",
            opt_business_purpose_purchase_inventory: "Buy inventory or materials",
            opt_business_purpose_purchase_new_equipment: "Buy or repair equipment",
            opt_business_purpose_expansion: "Expand or open a new location",
            opt_business_purpose_renovations: "Renovations",
            opt_business_purpose_sales_and_marketing: "Sales & marketing",
            opt_business_purpose_hire_or_pay_staff: "Hire or pay staff",
            opt_business_purpose_invest_in_technology: "Invest in technology",
            opt_business_purpose_start_a_business: "Start a new business",
            opt_business_purpose_other: "Other",
            // - number_of_employees
            opt_number_of_employees_1: "Just me",
            opt_number_of_employees_2_5: "2 to 5",
            opt_number_of_employees_6_10: "6 to 10",
            opt_number_of_employees_11_50: "11 to 50",
            opt_number_of_employees_51_plus: "51 or more",
            // - business_type (POS)
            opt_business_type_pos_retail: "RETAIL",
            opt_business_type_pos_home_improvement: "HOME IMPROVEMENT",
            opt_business_type_pos_powersports: "POWERSPORTS",
            opt_business_type_pos_automotive: "AUTOMOTIVE",
            opt_business_type_pos_healthcare: "HEALTHCARE",
            // - asset_type
            opt_asset_type_inventory: "Inventory",
            opt_asset_type_machinery: "Machinery",
            opt_asset_type_industrial_equipment: "Industrial Equipment",
            opt_asset_type_farming_equipment: "Farming Equipment",
            opt_asset_type_retail_equipment: "Retail Equipment",
            opt_asset_type_restaurant_equipment: "Restaurant Equipment",
            opt_asset_type_it_office_equipment: "IT/Office Equipment",
            opt_asset_type_commercial_vehicle: "Commercial Vehicle",
            opt_asset_type_tractor: "Tractor",
            opt_asset_type_forklift: "Forklift",
            opt_asset_type_excavator: "Excavator/Construction Vehicle",
            opt_asset_type_truck: "Big Rig or Truck",
            opt_asset_type_other: "Other asset, please specify",
            // - payment_processor
            opt_business_payment_processor_chase_paymentech: "CHASE PAYMENTECH",
            opt_business_payment_processor_debitech: "DEBITECH",
            opt_business_payment_processor_desjardins: "DESJARDINS",
            opt_business_payment_processor_elavon: "ELAVON",
            opt_business_payment_processor_everlink: "EVERLINK",
            opt_business_payment_processor_first_data: "FIRST DATA",
            opt_business_payment_processor_global_payments: "GLOBAL PAYMENTS",
            opt_business_payment_processor_mercury_payments: "MERCURY PAYMENTS",
            opt_business_payment_processor_moneris: "MONERIS",
            opt_business_payment_processor_monex: "MONEX",
            opt_business_payment_processor_payfirma: "PAYFIRMA",
            opt_business_payment_processor_pivotal_payments: "PIVOTAL PAYMENTS",
            opt_business_payment_processor_pos_west: "POS WEST",
            opt_business_payment_processor_square: "SQUARE",
            opt_business_payment_processor_stripe: "STRIPE",
            opt_business_payment_processor_td_merchant_services: "TD MERCHANT SERVICES",
            opt_business_payment_processor_other: "OTHER",
            opt_business_payment_processor_none: "NONE",
            // car refinancing
            // own_car
            opt_car_refinancing_own: 'Own',
            opt_car_refinancing_finance: 'Finance',
            opt_car_refinancing_lease: 'Lease',
            // US income types
            opt_income_type_employed: 'Employed',
            opt_income_type_social_security: 'Benefits',
            // US bank account
            opt_bank_checking: 'Checking account',
            opt_bank_savings: 'Savings account',
            opt_bank_none: "I don't have a bank account",
            opt_bank_length_1_less: 'Less than 1 month',
            opt_bank_length_1_3: '1-3 months',
            opt_bank_length_3_6: '3-6 months',
            opt_bank_length_6_12: '6-12 months',
            opt_bank_length_1_2_years: '1-2 years',
            opt_bank_length_2_5_years: '2-5 years',
            opt_bank_length_5_more: 'More than 5 years',
        },
        placeholders: {
            select: "Select...",
            your_email: "your@email.com",
            income_type: "Select your main income source...",
            income_type_other: "Please specify...",
            type_to_search: "Type to search...",
            address_number: 'Number',
            address_street: 'Street',
            address_unit: 'Apt 8, Suite 2, etc. (optional)',
            address_city: "City",
            select_date: "Select date...",
            date_format: "YYYY-MM-DD",
            select_month: "Select month and year...",
            // car refinancing
            your_current_lender: 'Your current lender',
            // US banking / driver's license
            routing_number: 'Routing Number',
            account_number: 'Account Number',
            bank_name: 'Bank Name',
            drivers_license_number: "Driver's License Number",
        },
        textBottom: {
            phone_number_sms_results: '<small style="display: block; font-size: 0.7em; padding-left: 2px; margin-top: -14px;">You will receive a 1-time SMS with your results (reply "STOP" to stop).</small>'
        }
    },
    submissionLoading: {
        searching_providers: 'Searching for the best options...',
        evaluating_options: 'Evaluating your options...',
        do_not_refresh: 'Please do not refresh the page',
        almost_there: 'Almost there! Finding the best results for you...',
        do_not_leave: 'Please do not leave this page',
        options_available: 'Good news! Options are available in your area',
    },
    buttons: {
        more_info: 'More information',
        submit: 'Submit',
        skip: 'Skip',
        address_not_listed: 'My address is not listed',
        next: 'Next',
        request_code: 'Request Code',
        request_another_code: 'Request Another Code',
        edit: 'Edit'
    }
}
